import type { JSX } from 'react';

interface PlayerStatTextProps {
  className?: string;
  text: string;
  icon?: JSX.Element;
}

export default function PlayerStatText({ className = '', text, icon }: PlayerStatTextProps) {
  return (
    <div className={`col-span-3 flex items-center justify-end gap-1 ${className}`}>
      <span className="line-clamp-2 break-all text-right font-robotoMedium font-medium text-[12px] leading-[16px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
        {text || '-'}
      </span>
      {icon}
    </div>
  );
}
